<template>
  <div class="c-config-content">
    <h4>{{ $t('moh') }}</h4>
    <div class="row">
      <div class="col-md-6">
        <recording-select :client-id="client._id" :model="client" attribute="moh" :errors="formErrors"></recording-select>
      </div>
    </div>
  </div>
</template>
<script>
import RecordingSelect from "@/components/ClientRecordingSelect.vue";
export default {
    props: ['client'],
    components: {RecordingSelect},
    data() {
      return {
        formErrors: [],
      }
    },
    i18n: {
      messages: {
        vi: {
          moh: "Nhạc chờ giữ máy"
        },
        en: {
          moh: "Nhạc chờ giữ máy"
        }
      }
    }
}
</script>
<style scoped>

</style>